/**
 * PollView — голосование без правильного ответа (kind="poll").
 *
 * Механика та же, что у choice (выбор варианта-кнопки →
 * onAnswer({kind:'poll', option})), но без подсветки «верного»: у опроса нет
 * правильного ответа, и сервер не присылает reveal. После голоса — бейдж
 * «Голос принят». Spectate (ведущий): распределение голосов барами (counts).
 */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { choiceOptions, type PlayerAnswer } from '../../protocol';
import { OptionsBoard } from './OptionsBoard';
import type { QuestionBodyProps } from './types';

export function PollView({
  question,
  variant,
  myAnswer,
  counts,
  onAnswer,
}: QuestionBodyProps): JSX.Element {
  const { t } = useTranslation();
  const options = choiceOptions(question);
  const initial = myAnswer?.kind === 'poll' ? myAnswer.option : null;
  const [selected, setSelected] = useState<number | null>(initial);

  // У poll нет правильного ответа → reveal не приходит, верный вариант не подсвечиваем.
  const locked = variant === 'answer' && selected !== null;

  function handlePick(i: number): void {
    if (locked) return;
    setSelected(i);
    const answer: PlayerAnswer = { kind: 'poll', option: i };
    onAnswer(answer);
  }

  return (
    <>
      <OptionsBoard
        options={options}
        variant={variant}
        selected={selected}
        locked={locked}
        correctOption={null}
        counts={counts}
        showCorrectMark={false}
        onPick={handlePick}
      />
      {variant === 'answer' && locked ? (
        <p className="q-hint q-hint--ok" role="status">
          {t('poll.voteAccepted')}
        </p>
      ) : null}
    </>
  );
}
